import { render, staticRenderFns } from "./mgmtMasterData.vue?vue&type=template&id=23351815&scoped=true&"
import script from "./mgmtMasterData.vue?vue&type=script&lang=js&"
export * from "./mgmtMasterData.vue?vue&type=script&lang=js&"
import style0 from "./mgmtMasterData.vue?vue&type=style&index=0&id=23351815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23351815",
  null
  
)

export default component.exports